<router-outlet></router-outlet>
<ng-template #overlayHost raComponentHost></ng-template>
<ra-app-loader [hidden]="!isLoading"></ra-app-loader>